export default __webpack_public_path__ + "static/media/filterIcon.d0c9a7cb.svg";